import React from 'react'
import axios from 'axios'
import { IntlShape } from 'react-intl'

interface IClientNotAllowedDetails {
  reason?: string
  clientName?: string
  ownerName?: string
}

export interface IGetClientNotAllowedMessageParams {
  error: unknown
  formatMessage: IntlShape['formatMessage']
}

const bold = (chunks: React.ReactNode[]) => React.createElement('b', { key: 'bold' }, chunks)

export function getClientNotAllowedMessage({ error, formatMessage }: IGetClientNotAllowedMessageParams): React.ReactNode | null {
  if (!axios.isAxiosError(error) || error.response?.data?.error !== 'client_not_allowed') {
    return null
  }

  const details: IClientNotAllowedDetails | undefined = error.response.data.error_details
  const clientName = details?.clientName ?? ''

  if (details?.reason === 'personal') {
    if (details.ownerName) {
      return formatMessage({ id: 'oauth.authorize.clientNotAllowed.personal' }, { clientName, ownerName: details.ownerName, b: bold })
    }
    return formatMessage({ id: 'oauth.authorize.clientNotAllowed.personalOtherCompany' }, { clientName, b: bold })
  }

  if (details?.reason === 'company') {
    return formatMessage({ id: 'oauth.authorize.clientNotAllowed.company' }, { clientName, b: bold })
  }

  return null
}
